import * as tslib_1 from "tslib";
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NavigationService } from '../services/navigation/navigation.service';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
import * as i2 from "../services/navigation/navigation.service";
var RedirectAuthenticatedGuard = /** @class */ (function () {
    function RedirectAuthenticatedGuard(authenticationService, navigationService) {
        this.authenticationService = authenticationService;
        this.navigationService = navigationService;
    }
    RedirectAuthenticatedGuard.prototype.canActivate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var firstVisibleItem;
            return tslib_1.__generator(this, function (_a) {
                if (this.authenticationService.permissions.length) {
                    firstVisibleItem = this.navigationService.getFirstVisibleItem(false);
                    if (firstVisibleItem) {
                        location.href = firstVisibleItem.url;
                        return [2 /*return*/, false];
                    }
                }
                return [2 /*return*/, true];
            });
        });
    };
    RedirectAuthenticatedGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RedirectAuthenticatedGuard_Factory() { return new RedirectAuthenticatedGuard(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.NavigationService)); }, token: RedirectAuthenticatedGuard, providedIn: "root" });
    return RedirectAuthenticatedGuard;
}());
export { RedirectAuthenticatedGuard };
